import { useFeatureFlag } from '../hooks/useFeatureFlag';

export interface IIfFeatureEnabledMSR3Props extends React.PropsWithChildren {
  /**
   * When to show the children:
   * - "true": Show only when flag is explicitly "true"
   * - "false": Show when flag is NOT "true" (false, undefined, or missing - fallback behavior)
   */
  isEnabled?: 'false' | 'true';
  /**
   * Additional gate applied after the feature flag resolves (and after loading).
   * Defaults to true. Use for extra UI conditions (e.g. zero bank accounts).
   */
  isVisible?: boolean;
  name: string | string[];
}

export const IfFeatureEnabledMSR3 = ({
  children,
  isEnabled = 'true',
  isVisible = true,
  name,
}: IIfFeatureEnabledMSR3Props) => {
  const [flagValue, featuresQuery] = useFeatureFlag(name);

  // Don't render anything while features are loading to avoid flash of incorrect content
  if (featuresQuery.isLoading) return null;

  // isEnabled="true" -> show when flag is explicitly "true"
  // isEnabled="false" -> show when flag is NOT "true" (false, undefined, or missing)
  const flagMatches = isEnabled === 'true' ? flagValue : !flagValue;
  const isFlagVisible = flagMatches && isVisible;

  return isFlagVisible ? <>{children}</> : null;
};

export default IfFeatureEnabledMSR3;
